// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2Adrx","gfeWrapper":"CalendarEvent_gfeWrapper__2iJsc"};